import { Box, Container, Paper, Typography } from '@mui/material';
import { Calendar, Award, Layers, Languages, Building2 } from 'lucide-react';

export function QuickInfo({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const info = data.quick_info;

  if (!info || typeof info !== 'object') return null;

  const items = [];
  if (info.established) items.push({ label: 'Established', value: info.established, icon: Calendar });
  if (info.affiliation) items.push({ label: 'Affiliation', value: info.affiliation, icon: Award });
  if (info.classes) items.push({ label: 'Classes Offered', value: info.classes, icon: Layers });
  if (info.medium) items.push({ label: 'Medium of Instruction', value: info.medium, icon: Languages });
  if (info.school_type) items.push({ label: 'School Type', value: info.school_type, icon: Building2 });

  if (items.length === 0) return null;

  return (
    <Box sx={{ mt: { xs: -4, md: -6 }, position: 'relative', zIndex: 10, mb: 8 }}>
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 3.5 },
            borderRadius: 4,
            backgroundColor: '#ffffff',
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.08)',
            border: '1px solid #f1f5f9',
          }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
                md: `repeat(${items.length}, 1fr)`,
              },
              gap: { xs: 3, md: 2 },
              alignItems: 'center',
            }}
          >
            {items.map((item, index) => {
              const IconComp = item.icon;
              return (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    position: 'relative',
                    px: { md: 1 },
                    borderRight: {
                      md: index < items.length - 1 ? '1px solid #f1f5f9' : 'none',
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: 3,
                      backgroundColor: `${primaryColor}10`,
                      color: primaryColor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <IconComp size={22} />
                  </Box>
                  <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      fontWeight={700}
                      display="block"
                      sx={{
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        lineHeight: 1.2,
                        mb: 0.5,
                        fontSize: '0.7rem',
                      }}
                    >
                      {item.label}
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      fontWeight={800}
                      color="#0f172a"
                      sx={{ lineHeight: 1.3, wordBreak: 'break-word' }}
                    >
                      {item.value}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default QuickInfo;
